module.exports = __webpack_public_path__ + "img/icon_questions.6891c416.svg";